import { FetchCallback, FilterManager } from "@search";
// import { AccommodationFilter } from "@graphql";
import { Filter, initialFilter } from "./utils";

export class AccommodationFilterManager extends FilterManager<Filter> {
  constructor(_initialFilter: Partial<Filter>, fetch: FetchCallback) {
    super({ initialFilter: { ...initialFilter, ..._initialFilter } }, fetch);
  }
  // not implemented yet
}
